<template>
  <div class="cobrancas-taxa-fixa">
    <ul v-if="value.length" class="cobrancas-taxa-fixa__etiquetas" aria-label="Cobranças escolhidas">
      <li v-for="cobranca in value" :key="`${typeof cobranca.id}-${cobranca.id}`" class="cobrancas-taxa-fixa__etiqueta">
        <strong class="cobrancas-taxa-fixa__codigo">{{ cobranca.id }}</strong>
        <span class="cobrancas-taxa-fixa__nome">{{ nomeCurto(cobranca) }}</span>
        <button
          type="button"
          class="cobrancas-taxa-fixa__remover"
          :aria-label="`Remover cobrança ${nomeCurto(cobranca)}`"
          :title="`Remover cobrança ${nomeCurto(cobranca)}`"
          @click="remover(cobranca)"
        >
          <fa-icon icon="times" />
        </button>
      </li>
    </ul>
    <p v-else class="cobrancas-taxa-fixa__todas" role="status">
      <fa-icon icon="layer-group" class="cobrancas-taxa-fixa__todas-icone" />
      <strong>Todas as cobranças com taxa fixa</strong>
    </p>
    <SeletorBusca
      :value="null"
      :url="url"
      :mapear="mapear"
      :ocultar="ids"
      :placeholder="value.length ? 'Digite para buscar e adicionar outra cobrança' : 'Digite para limitar a regra a algumas cobranças'"
      :texto-vazio="value.length ? 'Nenhuma outra cobrança com taxa fixa encontrada' : 'Nenhuma cobrança com taxa fixa encontrada'"
      aria-label="Adicionar cobrança"
      @change="adicionar"
    >
      <template #opcao="{ opcao }">
        <span class="cobrancas-taxa-fixa__opcao">
          <strong class="cobrancas-taxa-fixa__codigo">{{ opcao.id }}</strong>
          <span class="cobrancas-taxa-fixa__nome">{{ nomeCurto(opcao) }}</span>
          <span v-if="opcao.valor" class="cobrancas-taxa-fixa__valor">{{ opcao.valor }}</span>
        </span>
      </template>
    </SeletorBusca>
  </div>
</template>

<script>
import SeletorBusca from "@/components/form/SeletorBusca.vue";
import { formatarTaxaFixa, nomeCobranca } from "../../../helpers/regraNegocio";

export const URL_COBRANCAS_TAXA_FIXA = "/admin/regras-negocio/cobrancas-taxa-fixa";

export const mapearCobrancaTaxaFixa = (cobranca) => ({
  id: cobranca.id,
  descricao: cobranca.descricao || "",
  valor: formatarTaxaFixa(cobranca.taxafixa),
});

export default {
  name: "CobrancasTaxaFixa",
  components: { SeletorBusca },

  props: {
    value: { type: Array, default: () => [] },
    url: { type: String, default: URL_COBRANCAS_TAXA_FIXA },
  },

  data() {
    return { mapear: mapearCobrancaTaxaFixa };
  },

  computed: {
    ids() {
      return this.value.map((cobranca) => cobranca.id);
    },
  },

  methods: {
    nomeCurto(cobranca) {
      return nomeCobranca(cobranca);
    },

    adicionar(id, opcao) {
      if (id === null || id === undefined || this.ids.some((atual) => String(atual) === String(id))) return;

      this.$emit("input", [...this.value, { id, descricao: (opcao && opcao.descricao) || "" }]);
    },

    remover(cobranca) {
      this.$emit(
        "input",
        this.value.filter((atual) => String(atual.id) !== String(cobranca.id))
      );
    },
  },
};
</script>

<style scoped>
.cobrancas-taxa-fixa__etiquetas {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 8px;
  padding: 0;
  list-style: none;
}

.cobrancas-taxa-fixa__todas {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  margin: 0 0 8px;
  padding: 6px 10px;
  border: 1px solid var(--cashback-cor-primaria, #3a3e81);
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.3;
  color: var(--cashback-cor-primaria, #3a3e81);
  background-color: #eef0fb;
}

.cobrancas-taxa-fixa__todas-icone {
  flex-shrink: 0;
}

.cobrancas-taxa-fixa__etiqueta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 5px 6px 5px 6px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.3;
  color: #344054;
  background-color: #f9fafb;
}

.cobrancas-taxa-fixa__codigo {
  flex-shrink: 0;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 12px;
  color: #344054;
  background-color: #eaecf0;
}

.cobrancas-taxa-fixa__nome {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cobrancas-taxa-fixa__remover {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  font-size: 12px;
  color: #667085;
  background: transparent;
  cursor: pointer;
}

.cobrancas-taxa-fixa__remover:hover,
.cobrancas-taxa-fixa__remover:focus-visible {
  color: #b42318;
  background-color: #fee4e2;
}

.cobrancas-taxa-fixa__opcao {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.cobrancas-taxa-fixa__opcao .cobrancas-taxa-fixa__nome {
  flex: 1;
}

.cobrancas-taxa-fixa__valor {
  flex-shrink: 0;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #344054;
}
</style>
